import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_dark.png'
import _imports_1 from '@/assets/images/new/illustration.png'
import _imports_2 from '@/assets/images/step1.png'
import _imports_3 from '@/assets/images/sunpay/step1.png'
import _imports_4 from '@/assets/images/step3.png'
import _imports_5 from '@/assets/images/sunpay/step3.png'
import _imports_6 from '@/assets/images/icon-copy.png'
import _imports_7 from '../../assets/images/bg-gery.png'


_pushScopeId("data-v-4901d5fa")
const _hoisted_1 = {
  key: 0,
  class: "embed-blocked"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/29.png",
    alt: "blocked"
  })
], -1)
const _hoisted_3 = {
  key: 1,
  class: "loading sunpay-cashier-boot"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "three-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "three-body__dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "three-body__dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "three-body__dot" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "ctx"
}
const _hoisted_7 = { class: "brand" }
const _hoisted_8 = {
  key: 0,
  class: "logo"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 1,
  src: _imports_0
}
const _hoisted_11 = { class: "lang" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 0,
  class: "slogan animated fadeInLeft"
}
const _hoisted_14 = { class: "title font-bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "illustration" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  draggable: "false"
}, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "desc"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "order"
}
const _hoisted_21 = { class: "head" }
const _hoisted_22 = { class: "title font-bold" }
const _hoisted_23 = { class: "icon" }
const _hoisted_24 = {
  key: 0,
  src: _imports_2
}
const _hoisted_25 = {
  key: 1,
  src: _imports_3
}
const _hoisted_26 = { class: "tname" }
const _hoisted_27 = { class: "time" }
const _hoisted_28 = { class: "block" }
const _hoisted_29 = { class: "block" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1)
const _hoisted_31 = { class: "block" }
const _hoisted_32 = { class: "block" }
const _hoisted_33 = { class: "body" }
const _hoisted_34 = { class: "container" }
const _hoisted_35 = { class: "project" }
const _hoisted_36 = { class: "list" }
const _hoisted_37 = {
  key: 0,
  class: "item active"
}
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-4901d5fa><div class=\"icon\" data-v-4901d5fa><img src=\"/images/sunpay.png\" alt=\"Sun Pay\" data-v-4901d5fa></div><div class=\"value\" data-v-4901d5fa><div class=\"name\" data-v-4901d5fa>Sun Pay</div></div></div>", 1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "item active"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-4901d5fa><div class=\"icon\" data-v-4901d5fa><img src=\"/images/icon-logo.png\" alt=\"Klickl Pay\" data-v-4901d5fa></div><div class=\"value\" data-v-4901d5fa><div class=\"name\" data-v-4901d5fa>Klickl Pay</div></div></div>", 1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 0,
  class: "footer"
}
const _hoisted_44 = { class: "total" }
const _hoisted_45 = {
  key: 0,
  class: "item"
}
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "item" }
const _hoisted_48 = { class: "number font-bold" }
const _hoisted_49 = { class: "action font-bold" }
const _hoisted_50 = { class: "pay" }
const _hoisted_51 = { class: "head" }
const _hoisted_52 = { class: "title font-bold" }
const _hoisted_53 = { class: "icon" }
const _hoisted_54 = {
  key: 0,
  src: _imports_4
}
const _hoisted_55 = {
  key: 1,
  src: _imports_5
}
const _hoisted_56 = { class: "desc" }
const _hoisted_57 = { class: "body" }
const _hoisted_58 = { class: "container" }
const _hoisted_59 = {
  key: 0,
  class: "form"
}
const _hoisted_60 = { class: "label required" }
const _hoisted_61 = { class: "value" }
const _hoisted_62 = {
  key: 1,
  class: "result"
}
const _hoisted_63 = {
  key: 0,
  class: "project"
}
const _hoisted_64 = { class: "amount font-bold" }
const _hoisted_65 = { class: "desc" }
const _hoisted_66 = { class: "qrcode" }
const _hoisted_67 = { class: "subtitle" }
const _hoisted_68 = { class: "paycode" }
const _hoisted_69 = { class: "input border" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "subtitle" }
const _hoisted_73 = { class: "paycode" }
const _hoisted_74 = { class: "input border" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = { class: "tips" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "footer" }
const _hoisted_81 = { class: "action font-bold" }
const _hoisted_82 = {
  key: 1,
  class: "status"
}
const _hoisted_83 = {
  key: 0,
  class: "loader"
}
const _hoisted_84 = {
  key: 1,
  class: "icon"
}
const _hoisted_85 = ["src", "alt"]
const _hoisted_86 = {
  key: 2,
  class: "name"
}
const _hoisted_87 = { class: "amount" }
const _hoisted_88 = {
  key: 3,
  class: "name"
}
const _hoisted_89 = {
  key: 4,
  class: "infos"
}
const _hoisted_90 = { class: "label" }
const _hoisted_91 = { class: "value" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.66653 3.99999V1.99999C4.66653 1.63181 4.96501 1.33333 5.3332 1.33333H13.3332C13.7014 1.33333 13.9999 1.63181 13.9999 1.99999V11.3333C13.9999 11.7015 13.7014 12 13.3332 12H11.3332V13.9994C11.3332 14.3679 11.0333 14.6667 10.662 14.6667H2.67111C2.30039 14.6667 2 14.3703 2 13.9994L2.00173 4.66724C2.0018 4.29874 2.30176 3.99999 2.67295 3.99999H4.66653ZM3.33495 5.33333L3.33346 13.3333H9.99987V5.33333H3.33495ZM5.99987 3.99999H11.3332V10.6667H12.6665V2.66666H5.99987V3.99999Z",
    fill: "#929292"
  })
], -1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 5,
  class: "infos"
}
const _hoisted_95 = { class: "label" }
const _hoisted_96 = { class: "value" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.66653 3.99999V1.99999C4.66653 1.63181 4.96501 1.33333 5.3332 1.33333H13.3332C13.7014 1.33333 13.9999 1.63181 13.9999 1.99999V11.3333C13.9999 11.7015 13.7014 12 13.3332 12H11.3332V13.9994C11.3332 14.3679 11.0333 14.6667 10.662 14.6667H2.67111C2.30039 14.6667 2 14.3703 2 13.9994L2.00173 4.66724C2.0018 4.29874 2.30176 3.99999 2.67295 3.99999H4.66653ZM3.33495 5.33333L3.33346 13.3333H9.99987V5.33333H3.33495ZM5.99987 3.99999H11.3332V10.6667H12.6665V2.66666H5.99987V3.99999Z",
    fill: "#929292"
  })
], -1)
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { class: "label" }
const _hoisted_101 = { class: "value" }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { class: "label" }
const _hoisted_104 = { class: "value" }
const _hoisted_105 = { key: 2 }
const _hoisted_106 = { class: "label" }
const _hoisted_107 = { class: "value" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = { key: 3 }
const _hoisted_111 = { class: "label" }
const _hoisted_112 = { class: "value" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { key: 4 }
const _hoisted_116 = { class: "label" }
const _hoisted_117 = { class: "value links" }
const _hoisted_118 = { class: "value full" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { class: "tips" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { key: 1 }
const _hoisted_123 = { class: "line" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "label" }
const _hoisted_126 = { class: "value" }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "copy"
}, null, -1)
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("li", { class: "line" }, null, -1)
const _hoisted_131 = { class: "item" }
const _hoisted_132 = { class: "label" }
const _hoisted_133 = { class: "value" }
const _hoisted_134 = {
  key: 0,
  class: "down"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-down" }, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/images/down-arrow.png",
      alt: "down-arrow"
    })
  ])
], -1)
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = {
  key: 6,
  class: "formflow"
}
const _hoisted_138 = /*#__PURE__*/_createStaticVNode("<div class=\"tips\" data-v-4901d5fa><span data-v-4901d5fa><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" data-v-4901d5fa><path d=\"M12.6667 6.66663H13.3333C13.7015 6.66663 14 6.9651 14 7.3333V14C14 14.3682 13.7015 14.6666 13.3333 14.6666H2.66667C2.29848 14.6666 2 14.3682 2 14V7.3333C2 6.9651 2.29848 6.66663 2.66667 6.66663H3.33333V5.99996C3.33333 3.42264 5.42267 1.3333 8 1.3333C10.5773 1.3333 12.6667 3.42264 12.6667 5.99996V6.66663ZM3.33333 7.99996V13.3333H12.6667V7.99996H3.33333ZM7.33333 9.3333H8.66667V12H7.33333V9.3333ZM11.3333 6.66663V5.99996C11.3333 4.15902 9.84093 2.66663 8 2.66663C6.15905 2.66663 4.66667 4.15902 4.66667 5.99996V6.66663H11.3333Z\" fill=\"#5B5B5B\" data-v-4901d5fa></path></svg> Secured Payment </span></div><div class=\"title\" data-v-4901d5fa><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" data-v-4901d5fa><path d=\"M2.25366 2.24982H15.7537C16.1679 2.24982 16.5037 2.5856 16.5037 2.99982V14.9998C16.5037 15.414 16.1679 15.7498 15.7537 15.7498H2.25366C1.83945 15.7498 1.50366 15.414 1.50366 14.9998V2.99982C1.50366 2.5856 1.83945 2.24982 2.25366 2.24982ZM15.0037 8.24982H3.00366V14.2498H15.0037V8.24982ZM15.0037 6.74982V3.74982H3.00366V6.74982H15.0037ZM10.5037 11.2498H13.5037V12.7498H10.5037V11.2498Z\" fill=\"black\" data-v-4901d5fa></path></svg> Card </div>", 2)
const _hoisted_140 = { class: "form" }
const _hoisted_141 = { class: "item full" }
const _hoisted_142 = { class: "item full" }
const _hoisted_143 = { class: "svgs" }
const _hoisted_144 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "9",
  viewBox: "0 0 28 9",
  fill: "none"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.4198 1.75269C16.955 1.75269 16.5587 2.00408 16.4978 2.43843C16.4978 3.37572 19.5992 3.49769 19.5992 5.62373C19.5992 7.31542 18.0828 8.43558 15.6443 8.37462C14.8518 8.37462 13.9984 8.24512 13.2059 7.94031L13.6021 6.18762C14.326 6.50005 15.1185 6.69058 15.911 6.69058C16.5664 6.69058 17.2293 6.43906 17.2293 5.87516C17.2979 5.50177 16.9626 5.25035 16.1092 4.87696C15.3167 4.50357 14.1965 3.87872 14.1965 2.68996C14.1965 1.12782 15.7815 0 17.9533 0C18.6086 0 19.3401 0.129536 19.9955 0.373384L19.5992 2.12607C18.9363 1.81364 18.1514 1.69173 17.4198 1.75269ZM6.86582 8.32132H4.48831L2.70518 1.82124C2.62136 1.52406 2.43847 1.25733 2.17938 1.13541C1.52405 0.822977 0.792503 0.571491 0 0.449567V0.198133H3.82536C4.35115 0.198133 4.7474 0.571483 4.81598 1.01346L5.73803 5.70754L8.10792 0.205761H10.4169L6.8582 8.33648L6.86582 8.32132ZM11.7428 8.32132H9.50242L11.3465 0.190506H13.5869L11.7428 8.32132ZM25.6573 0.190506L27.4404 8.32132H25.3982L25.1315 7.13252H22.2968L21.8396 8.32132H19.5306L22.8302 0.815323C22.9597 0.441932 23.356 0.190506 23.7522 0.190506H25.6649H25.6573ZM24.0723 2.37751L24.7276 5.44085H22.8835L24.0723 2.37751Z",
  fill: "#172B85"
}, null, -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "17",
  viewBox: "0 0 22 17",
  fill: "none"
}
const _hoisted_148 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.56798 16.0543H5.94535V14.3529H5.56798V14.5571C5.45043 14.4024 5.27101 14.3096 5.02355 14.3096C4.54099 14.3096 4.15742 14.6808 4.15742 15.2005C4.15742 15.7202 4.5348 16.0913 5.02355 16.0913C5.27101 16.0913 5.45043 15.9923 5.56798 15.8439V16.0481V16.0543ZM7.09608 14.3096C7.3683 14.3096 7.62194 14.3715 7.80135 14.489L7.64051 14.786C7.53534 14.7241 7.325 14.6375 7.10227 14.6375C6.89811 14.6375 6.77438 14.7117 6.77438 14.8354C6.77438 14.9468 6.9043 14.9839 7.06516 15.0025L7.24456 15.0272C7.62194 15.0829 7.84466 15.2376 7.84466 15.5345C7.84466 15.8562 7.5539 16.0913 7.05896 16.0913C6.78056 16.0913 6.51454 16.0171 6.31038 15.8686L6.48978 15.5779C6.61352 15.6769 6.80532 15.7572 7.06516 15.7572C7.325 15.7572 7.46109 15.683 7.46109 15.5531C7.46109 15.4541 7.36211 15.4046 7.15795 15.3737L6.97853 15.349C6.59496 15.2933 6.38462 15.1262 6.38462 14.8478C6.38462 14.5075 6.66302 14.3034 7.10227 14.3034L7.09608 14.3096ZM8.82834 14.3529H9.44083V14.6931H8.82834V15.4603C8.82834 15.6335 8.89022 15.7449 9.07582 15.7449C9.17481 15.7449 9.29853 15.714 9.40989 15.6459L9.52126 15.9614C9.40372 16.0419 9.21192 16.0913 9.05107 16.0913C8.60563 16.0913 8.45096 15.8562 8.45096 15.4603V14.687H8.09832V14.3467H8.45096V13.8332H8.82834V14.3467V14.3529ZM10.6101 14.3096C10.1028 14.3096 9.75017 14.6746 9.75017 15.2005C9.75017 15.7264 10.1214 16.0913 10.6349 16.0913C10.8947 16.0913 11.1298 16.0295 11.3401 15.85L11.1545 15.5779C11.0122 15.6892 10.8266 15.7572 10.6534 15.7572C10.4121 15.7572 10.1894 15.6459 10.1399 15.3428H11.4206C11.4206 15.2995 11.4267 15.25 11.4267 15.2005C11.4267 14.6684 11.0927 14.3096 10.6101 14.3096ZM13.0229 15.2005C13.0229 15.714 13.3879 16.0913 13.9447 16.0913C14.2046 16.0913 14.3778 16.0357 14.5634 15.8872L14.384 15.5903C14.2417 15.6892 14.0932 15.7449 13.9323 15.7449C13.6354 15.7449 13.4127 15.5284 13.4127 15.2005C13.4127 14.8726 13.6354 14.6623 13.9323 14.6561C14.0932 14.6561 14.2417 14.7117 14.384 14.8107L14.5634 14.5137C14.3778 14.3652 14.2046 14.3096 13.9447 14.3096C13.3879 14.3096 13.0229 14.687 13.0229 15.2005ZM16.5369 16.0543H16.1595V15.85C16.042 16.0047 15.8626 16.0975 15.6151 16.0975C15.1326 16.0975 14.749 15.7264 14.749 15.2067C14.749 14.687 15.1264 14.3158 15.6151 14.3158C15.8626 14.3158 16.042 14.4148 16.1595 14.5632V14.359H16.5369V16.0604V16.0543ZM20.02 13.6661V16.0543H19.6426V15.85C19.5251 16.0047 19.3457 16.0975 19.0982 16.0975C18.6157 16.0975 18.2321 15.7264 18.2321 15.2067C18.2321 14.687 18.6095 14.3158 19.0982 14.3158C19.3457 14.3158 19.5251 14.4148 19.6426 14.5632V13.6723H20.02V13.6661ZM3.82333 16.0543V14.9839C3.82333 14.5818 3.56349 14.3096 3.14279 14.3096C2.92007 14.3096 2.69737 14.3714 2.53651 14.6127C2.41897 14.4209 2.22717 14.3096 1.96733 14.3096C1.78173 14.3096 1.60231 14.3653 1.46002 14.5632V14.3529H1.08264V16.0543H1.46002V15.1139C1.46002 14.8169 1.62707 14.6623 1.88073 14.6623C2.13438 14.6623 2.2581 14.8231 2.2581 15.1139V16.0604H2.6355V15.1201C2.6355 14.8231 2.80872 14.6684 3.05619 14.6684C3.30366 14.6684 3.43357 14.8293 3.43357 15.1201V16.0666H3.81096L3.82333 16.0543ZM12.6393 14.3096C12.4228 14.3096 12.2805 14.4086 12.1877 14.5571V14.3529H11.8165V16.0543H12.1939V15.1015C12.1939 14.8169 12.3176 14.6623 12.5651 14.6623C12.6393 14.6623 12.7198 14.6746 12.8002 14.7055L12.9177 14.359C12.8373 14.3281 12.726 14.3096 12.6517 14.3096H12.6393ZM17.8547 14.3096C17.6382 14.3096 17.4959 14.4086 17.3969 14.5571V14.3529H17.0257V16.0543H17.4031V15.1015C17.4031 14.8169 17.5268 14.6623 17.7743 14.6623C17.8485 14.6623 17.9289 14.6746 18.0094 14.7055L18.1269 14.359C18.0465 14.3281 17.9351 14.3096 17.8609 14.3096H17.8547ZM5.06686 14.6561C4.73896 14.6561 4.54099 14.9035 4.54099 15.2005C4.54099 15.4975 4.73896 15.7449 5.06686 15.7449C5.39475 15.7449 5.58653 15.5098 5.58653 15.2005C5.58653 14.8912 5.37619 14.6561 5.06686 14.6561ZM15.6584 14.6561C15.3305 14.6561 15.1326 14.9035 15.1326 15.2005C15.1326 15.4975 15.3305 15.7449 15.6584 15.7449C15.9863 15.7449 16.1781 15.5098 16.1781 15.2005C16.1781 14.8912 15.9678 14.6561 15.6584 14.6561ZM19.1415 14.6561C18.8136 14.6561 18.6157 14.9035 18.6157 15.2005C18.6157 15.4975 18.8136 15.7449 19.1415 15.7449C19.4694 15.7449 19.6612 15.5098 19.6612 15.2005C19.6612 14.8912 19.4509 14.6561 19.1415 14.6561ZM11.0308 15.052C10.9937 14.786 10.8328 14.6375 10.5915 14.6375C10.3255 14.6375 10.1709 14.8046 10.1337 15.052H11.0308Z",
  fill: "#231F20"
}, null, -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.3633 11.4638H7.67773V1.38574H13.3633V11.4638Z",
  fill: "#FF5F00"
}, null, -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.03647 6.42167C8.03647 4.38007 9.00779 2.55499 10.5173 1.37953C9.40992 0.519579 8.01793 0.00610352 6.50219 0.00610352C2.91393 0.00610352 0 2.87671 0 6.41548C0 9.95426 2.90774 12.8249 6.50219 12.8249C8.01793 12.8249 9.41611 12.3114 10.5173 11.4514C9.00779 10.276 8.03647 8.45708 8.03647 6.40929V6.42167Z",
  fill: "#EB001B"
}, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.0349 6.42176C21.0349 9.96054 18.1272 12.8311 14.5327 12.8311C13.017 12.8311 11.6188 12.3177 10.5176 11.4577C12.0271 10.2823 12.9984 8.46336 12.9984 6.41557C12.9984 4.36778 12.0271 2.54889 10.5176 1.37342C11.625 0.513475 13.017 0 14.5327 0C18.121 0 21.0349 2.8706 21.0349 6.40938V6.42176Z",
  fill: "#F79E1B"
}, null, -1)
const _hoisted_152 = [
  _hoisted_148,
  _hoisted_149,
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = {
  key: 2,
  style: {"width":"26px","height":"16px"},
  viewBox: "0 0 26 16",
  xmlns: "http://www.w3.org/2000/svg",
  color: "#727272",
  backgroundColor: "#ffffff",
  borderColor: "#DDDDDD",
  "data-testid": "CardSchemeMaestro",
  class: "fw63oc fv6bsz notranslate",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_24_776)" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "26",
    height: "16",
    rx: "2",
    fill: "#313159"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.09 12.36C12.4979 12.36 14.45 10.408 14.45 8C14.45 5.59204 12.4979 3.64 10.09 3.64C7.68202 3.64 5.72998 5.59204 5.72998 8C5.72998 10.408 7.68202 12.36 10.09 12.36Z",
    fill: "#D92E28"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.91 12.36C18.3179 12.36 20.27 10.408 20.27 8C20.27 5.59204 18.3179 3.64 15.91 3.64C13.502 3.64 11.55 5.59204 11.55 8C11.55 10.408 13.502 12.36 15.91 12.36Z",
    fill: "#4299DA"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13 4.75322C12.11 5.55147 11.55 6.71035 11.55 8.00001C11.55 9.28967 12.11 10.4486 13 11.2468C13.89 10.4486 14.45 9.28967 14.45 8.00001C14.45 6.71035 13.89 5.55147 13 4.75322Z",
    fill: "#6C6DB9"
  })
], -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_24_776" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "26",
      height: "16",
      fill: "white"
    })
  ])
], -1)
const _hoisted_156 = [
  _hoisted_154,
  _hoisted_155
]
const _hoisted_157 = { class: "item" }
const _hoisted_158 = { class: "item" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "svgs" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 21",
    margin: "4px 0 0",
    width: "26",
    height: "20",
    color: "#000000",
    backgroundColor: "#FFFFFF",
    borderColor: "#DDDDDD",
    "data-testid": "CVV",
    class: "fmr5swq notranslate",
    "aria-hidden": "true",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#FFFFFF",
      d: "M0 0h18v14H0V0Z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#000000",
      "fill-rule": "evenodd",
      d: "M17 1H1v12h16V1ZM0 0v14h18V0H0Z",
      "clip-rule": "evenodd"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#000000",
      "fill-rule": "evenodd",
      d: "M17 4H1V2h16v2ZM7 11H3v-1h4v1Z",
      "clip-rule": "evenodd"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#FFFFFF",
      d: "M25.136 12.068a8.068 8.068 0 1 1-16.136 0 8.068 8.068 0 0 1 16.136 0Z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#000000",
      "fill-rule": "evenodd",
      d: "M17.068 4.5a7.568 7.568 0 1 0 0 15.136 7.568 7.568 0 0 0 0-15.136ZM8.5 12.068a8.568 8.568 0 1 1 17.136 0 8.568 8.568 0 0 1-17.136 0Z",
      "clip-rule": "evenodd"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#000000",
      d: "M20.582 14.634c-.375 0-.704-.061-.987-.184a1.61 1.61 0 0 1-.668-.52 1.52 1.52 0 0 1-.283-.79l-.004-.04h1.152l.007.037a.558.558 0 0 0 .118.28.7.7 0 0 0 .267.197.99.99 0 0 0 .395.072.9.9 0 0 0 .385-.075.611.611 0 0 0 .253-.214.55.55 0 0 0 .089-.31v-.006a.506.506 0 0 0-.214-.441c-.143-.1-.345-.151-.609-.151h-.513v-.82h.507c.155 0 .288-.023.398-.069a.57.57 0 0 0 .256-.194.475.475 0 0 0 .093-.29v-.006a.55.55 0 0 0-.08-.3.476.476 0 0 0-.223-.194.805.805 0 0 0-.349-.069.87.87 0 0 0-.365.072.586.586 0 0 0-.247.201.651.651 0 0 0-.109.303l-.003.033h-1.096l.004-.046c.022-.298.11-.556.263-.774.156-.219.365-.388.628-.506.266-.12.574-.181.925-.181.362 0 .676.055.941.164.266.108.47.258.616.451.144.193.217.42.217.678v.007c0 .2-.045.374-.135.523a1.077 1.077 0 0 1-.356.362 1.44 1.44 0 0 1-.49.197v.023c.358.035.642.148.852.34.211.19.316.442.316.756v.007c0 .298-.08.56-.24.783-.16.221-.386.393-.678.513-.292.12-.636.181-1.033.181ZM14.584 14.516v-.806l1.491-1.39c.233-.212.412-.386.54-.522.13-.139.218-.256.266-.353a.64.64 0 0 0 .076-.292v-.014a.61.61 0 0 0-.076-.309.51.51 0 0 0-.22-.204.756.756 0 0 0-.343-.072.754.754 0 0 0-.365.085.652.652 0 0 0-.332.58v.026l-1.106-.003v-.02c0-.316.077-.593.23-.83.156-.236.372-.42.649-.552.278-.134.602-.201.97-.201.354 0 .662.06.925.178.266.116.472.28.619.49.15.21.224.456.224.737v.016c0 .178-.038.355-.112.53a2.234 2.234 0 0 1-.369.563 6.926 6.926 0 0 1-.694.675l-1.1.964.333-.52v.52l-.332-.217h2.336v.94h-3.61ZM12.463 14.516v-3.66h-.062l-1.146.774v-1.04l1.208-.823h1.208v4.749h-1.208Z"
    })
  ])
], -1)
const _hoisted_160 = { class: "item full padding" }
const _hoisted_161 = { class: "flex" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  viewBox: "0 0 16 14",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.86629 5.83333V11.6667H12.2433V5.83333H3.86629ZM11.5989 4.66666H12.8877C13.2435 4.66666 13.532 4.92783 13.532 5.24999V12.25C13.532 12.5722 13.2435 12.8333 12.8877 12.8333H2.57752C2.22164 12.8333 1.93314 12.5722 1.93314 12.25V5.24999C1.93314 4.92783 2.22164 4.66666 2.57752 4.66666H3.86629V4.08333C3.86629 2.15033 5.59729 0.583328 7.73259 0.583328C9.86788 0.583328 11.5989 2.15033 11.5989 4.08333V4.66666ZM10.3101 4.66666V4.08333C10.3101 2.79466 9.15609 1.74999 7.73259 1.74999C6.30905 1.74999 5.15505 2.79466 5.15505 4.08333V4.66666H10.3101ZM4.51067 6.41666H5.79944V7.58333H4.51067V6.41666ZM4.51067 8.16666H5.79944V9.33333H4.51067V8.16666ZM4.51067 9.91666H5.79944V11.0833H4.51067V9.91666Z",
    fill: "white"
  })
], -1)
const _hoisted_163 = {
  key: 7,
  class: "flow"
}
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", {
  id: "flow-container",
  class: "flow-container"
}, null, -1)
const _hoisted_165 = {
  key: 0,
  class: "flow-sunpay-container"
}
const _hoisted_166 = { class: "brand" }
const _hoisted_167 = ["src"]
const _hoisted_168 = /*#__PURE__*/_createTextVNode(" Sun Pay")
const _hoisted_169 = ["href"]
const _hoisted_170 = /*#__PURE__*/_createStaticVNode("<div class=\"security\" data-v-4901d5fa><div class=\"slot\" data-v-4901d5fa><span class=\"secured-by\" data-v-4901d5fa>Secured By</span><figure data-v-4901d5fa><img class=\"forter-logo\" src=\"/images/forter.png\" alt=\"forter\" data-v-4901d5fa></figure></div><div class=\"slot\" data-v-4901d5fa><figure data-v-4901d5fa><img class=\"wetech-logo\" src=\"/images/wetech-logo.png\" alt=\"wetech\" data-v-4901d5fa></figure></div><div class=\"slot\" data-v-4901d5fa><figure data-v-4901d5fa><img class=\"pci-logo\" src=\"/images/pci.png\" alt=\"pci\" data-v-4901d5fa></figure></div></div><div id=\"last\" data-v-4901d5fa></div>", 2)
const _hoisted_172 = {
  key: 8,
  class: "action"
}
const _hoisted_173 = { class: "btn" }
const _hoisted_174 = ["action"]
const _hoisted_175 = ["value"]
const _hoisted_176 = ["value"]
const _hoisted_177 = ["value"]
const _hoisted_178 = ["value"]
const _hoisted_179 = ["value"]
const _hoisted_180 = ["value"]
const _hoisted_181 = ["value"]
const _hoisted_182 = ["value"]
const _hoisted_183 = ["action"]
const _hoisted_184 = ["value"]
const _hoisted_185 = {
  key: 0,
  class: "loading"
}
const _hoisted_186 = /*#__PURE__*/_createTextVNode(" Loading... ")
const _hoisted_187 = ["src"]
const _hoisted_188 = {
  key: 1,
  class: "payfac-iframe-mask"
}
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "payfac-iframe-mask__card" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "payfac-iframe-mask__spinner",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "Confirming your payment result...")
], -1)
const _hoisted_190 = [
  _hoisted_189
]
const _hoisted_191 = {
  key: 1,
  class: "payfac-transition"
}
const _hoisted_192 = { class: "payfac-transition__card" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("div", {
  class: "payfac-transition__spinner",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_194 = { class: "payfac-transition__amount" }
const _hoisted_195 = { class: "copyright" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:business@klicklpay.com" }, "business@klicklpay.com", -1)
const _hoisted_197 = {
  key: 0,
  class: "background"
}
const _hoisted_198 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "background"
}, null, -1)
const _hoisted_199 = [
  _hoisted_198
]
const _hoisted_200 = {
  key: 1,
  class: "loading"
}
const _hoisted_201 = /*#__PURE__*/_createElementVNode("div", { class: "three-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "three-body__dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "three-body__dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "three-body__dot" })
], -1)
const _hoisted_202 = [
  _hoisted_201
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_KP_INPUT = _resolveComponent("KP_INPUT")!
  const _component_KP_SELECT = _resolveComponent("KP_SELECT")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_ctx.embedBlocked)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("cashier.embedBlocked")), 1)
      ]))
    : (_ctx.isSunpayBootLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (_ctx.embedGuardReady)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["checkout-counter", [_ctx.data.dev, { status_view: [1, 2, 3, 4, 5, 6].includes(_ctx.data.FormData.orderStatus) }]])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["header", { opacity: _ctx.isOpacity }])
            }, [
              (!_ctx.lang)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.CashChannelList?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_ctx.CashChannelList[0].businessCashierLogo)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.CashChannelList[0].businessCashierLogo,
                                  alt: _ctx.CashChannelList[0].businessCashierName
                                }, null, 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.data.dev == 'sunpaysandbox' || _ctx.data.dev == 'sunpayprod')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_10))
                                ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.lang)
                      ? (_openBlock(), _createBlock(_component_van_popover, {
                          key: 0,
                          show: _ctx.showPopover,
                          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
                          actions: _ctx.data.Languages,
                          theme: "dark",
                          onSelect: _ctx.changeLang
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("span", _hoisted_11, [
                              _createElementVNode("img", {
                                src: `${_ctx.BASE_URL}images/${_ctx.locale}.png`,
                                alt: _ctx.locale
                              }, null, 8, _hoisted_12),
                              _createTextVNode(_toDisplayString(_ctx.getLangName), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["show", "actions", "onSelect"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["content", { opacity: _ctx.isOpacity }])
            }, [
              (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_i18n_t, {
                        keypath: "cashier.payin",
                        scope: "global"
                      }, {
                        br: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_i18n_t, {
                              keypath: "cashier.tip1",
                              scope: "global"
                            }, {
                              br: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["payment", {
          ordered:
            _ctx.showPayfacCardFormEarly ||
            (_ctx.data.FormData.orderStatus !== -1 && _ctx.data.FormData.orderStatus !== 0),
          padding: _ctx.data.FormData.orderStatus == 1,
          opacity: _ctx.isOpacity
        }])
              }, [
                (
            _ctx.data.FormData.orderStatus == 0
              && !_ctx.showPayfacCardFormEarly
              && !_ctx.silentAutoPreOrder
              && !_ctx.autoPreOrderHidePaytype
              && !_ctx.isLoadingToast
          )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["infos", { nexts: _ctx.step > 1 || _ctx.result, 'two-steps': !_ctx.isSunpayCashier }])
                    }, [
                      (!_ctx.isSunpayCashier)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_25))
                                ]),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("cashier.paytype")), 1)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                false
                                  ? (_openBlock(), _createBlock(_component_van_count_down, {
                                      key: 0,
                                      time: Number(_ctx.data.FormData.expiresIn) * 1000,
                                      format: "mm:ss",
                                      onFinish: _ctx.finish
                                    }, {
                                      default: _withCtx((timeData) => [
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.splitNumber(timeData.minutes)[0]), 1),
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.splitNumber(timeData.minutes)[1]), 1),
                                        _hoisted_30,
                                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.splitNumber(timeData.seconds)[0]), 1),
                                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.splitNumber(timeData.seconds)[1]), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["time", "onFinish"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, [
                                    (_ctx.data.dev === 'sunpaysandbox' || _ctx.data.dev === 'sunpayprod')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
                                  ])
                                ])
                              ]),
                              (_ctx.CashChannelList?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                      false
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                                            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.data.FormData.transactionFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.total")), 1),
                                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_49, [
                                      (_ctx.data.FormData.cancelUrl)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "btn cancel",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                                          }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: "btn next",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStep(true)))
                                      }, _toDisplayString(_ctx.step == _ctx.steps ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_54))
                                : (_openBlock(), _createElementBlock("img", _hoisted_55))
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.payinfo")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t("cashier.desc")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            (!_ctx.result)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.dynamicsFiledList.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicsFiledList, (field, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "item full",
                                            key: index
                                          }, [
                                            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.resverText(field?.field_name)), 1),
                                            _createElementVNode("div", _hoisted_61, [
                                              (field.type == 'text')
                                                ? (_openBlock(), _createBlock(_component_KP_INPUT, {
                                                    key: 0,
                                                    modelValue: _ctx.data.FormData[field.field_name],
                                                    "onUpdate:modelValue": ($event: any) => (_ctx.data.FormData[field.field_name] = $event),
                                                    type: 'text',
                                                    expand: field?.expand,
                                                    placeholder: field?.field_name
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "expand", "placeholder"]))
                                                : _createCommentVNode("", true),
                                              (field.type == 'select')
                                                ? (_openBlock(), _createBlock(_component_KP_SELECT, {
                                                    key: 1,
                                                    modelValue: _ctx.data.FormData[field.field_name],
                                                    "onUpdate:modelValue": ($event: any) => (_ctx.data.FormData[field.field_name] = $event),
                                                    index: index,
                                                    "field-name": field.field_name,
                                                    list: field.value,
                                                    onChange: _ctx.onSelectChange
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "index", "field-name", "list", "onChange"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  (
                        ['AlchemyPay'].includes(_ctx.data.FormData.channelCode) &&
                          ['QRIS', 'OVO', 'DIRECT'].includes(_ctx.data.FormData.paymentType)
                      )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                        _createElementVNode("div", _hoisted_64, [
                                          _createTextVNode(_toDisplayString(_ctx.$t("cashier.pay")) + " ", 1),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("cashier.qrcode")), 1),
                                        _createElementVNode("div", _hoisted_66, [
                                          _createVNode(_component_VueQrcode, {
                                            value: 
                            _ctx.data.FormData.paymentType == 'QRIS'
                              ? _ctx.data.FormData.extend.qrCode
                              : _ctx.data.FormData.extend.paymentCode || _ctx.data.FormData.extend.vaNumber
                          ,
                                            tag: "img",
                                            options: {
                            width: 180,
                            margin: 0
                          }
                                          }, null, 8, ["value"])
                                        ]),
                                        (
                          _ctx.data.FormData.extend.paymentCode &&
                            !_ctx.isCanSerialize(_ctx.data.FormData?.extend?.paymentCode)
                        )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t("cashier.paymentCode")), 1),
                                              _createElementVNode("div", _hoisted_68, [
                                                _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.data.FormData.extend.paymentCode || ""), 1),
                                                _createElementVNode("div", {
                                                  class: "extend border",
                                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copy(_ctx.data.FormData.extend.paymentCode)))
                                                }, _hoisted_71)
                                              ])
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (_ctx.data.FormData.extend.vaNumber)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t("cashier.vaNumber")), 1),
                                              _createElementVNode("div", _hoisted_73, [
                                                _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.data.FormData.extend.vaNumber || ""), 1),
                                                _createElementVNode("div", {
                                                  class: "extend border",
                                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copy(_ctx.data.FormData.extend.vaNumber)))
                                                }, _hoisted_76)
                                              ])
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_77, [
                                          (_ctx.data.FormData.paymentType == 'DIRECT')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_78, _toDisplayString(_ctx.$t("cashier.useBank", { name: _ctx.data.FormData.bankName })), 1))
                                            : _createCommentVNode("", true),
                                          (_ctx.data.FormData.paymentType == 'QRIS')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(_ctx.$t("cashier.useQRIS", { name: _ctx.data.FormData.paymentType })), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              (!_ctx.result && false)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "btn cancel",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextStep(false)))
                                  }, _toDisplayString(_ctx.$t("cashier.back")), 1))
                                : _createCommentVNode("", true),
                              (_ctx.data.FormData.cancelUrl)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "btn cancel",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                                  }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                                : _createCommentVNode("", true),
                              (!_ctx.result)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["btn next", { disabled: _ctx.isDisableConfirm }]),
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.nextStep(true)))
                                  }, _toDisplayString(_ctx.step == _ctx.steps ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 3))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                ([1, 2, 3, 4, 5, 6].includes(_ctx.data.FormData.orderStatus) || _ctx.showPayfacCardFormEarly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      (false && _ctx.data.FormData.orderStatus == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83))
                        : _createCommentVNode("", true),
                      (_ctx.data.FormData.orderStatus !== 1 && !(_ctx.showPayfacCardFormEarly && _ctx.data.FormData.orderStatus === 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _createElementVNode("img", {
                              src: 
                `${_ctx.BASE_URL}images/status/${_ctx.CashPayInOrderStatus[_ctx.data.FormData.orderStatus]}.png`
              ,
                              alt: _ctx.CashPayInOrderStatus[_ctx.data.FormData.orderStatus]
                            }, null, 8, _hoisted_85)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showPayfacCardFormEarly && _ctx.data.FormData.orderStatus === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.data.FormData.currency) + " " + _toDisplayString(_ctx.data.FormData.amount != null ? _ctx.data.FormData.amount.toFixed(2) : '--'), 1)
                          ]))
                        : (!_ctx.showPayfacCardFormEarly || _ctx.data.FormData.orderStatus !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["amount", {
                fail: [3, 4, 5, 6].includes(_ctx.data.FormData.orderStatus),
                success: _ctx.data.FormData.orderStatus == 2
              }])
                              }, _toDisplayString(_ctx.data.FormData.currency) + " " + _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)), 3),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`cashier.PayinStatus[${_ctx.data.FormData.orderStatus}]`)), 1)
                            ]))
                          : _createCommentVNode("", true),
                      (_ctx.showPayfacCardFormEarly && _ctx.data.FormData.orderStatus === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            _createElementVNode("ul", null, [
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("cashier.orderNo")), 1),
                                _createElementVNode("div", _hoisted_91, [
                                  _createTextVNode(_toDisplayString(_ctx.data.FormData.outOrderNo) + " ", 1),
                                  _createElementVNode("span", {
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copy(_ctx.data.FormData.outOrderNo)))
                                  }, _hoisted_93)
                                ])
                              ])
                            ])
                          ]))
                        : (!_ctx.showPayfacCardFormEarly || _ctx.data.FormData.orderStatus !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.$t("cashier.orderNo")), 1),
                                  _createElementVNode("div", _hoisted_96, [
                                    _createTextVNode(_toDisplayString(_ctx.data.FormData.outOrderNo) + " ", 1),
                                    _createElementVNode("span", {
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copy(_ctx.data.FormData.outOrderNo)))
                                    }, _hoisted_98)
                                  ])
                                ]),
                                (
                  (_ctx.data.FormData.channelCode !== 'Checkout' &&
                    !_ctx.data.FormData.channelCode.toLocaleLowerCase().includes('nuvei')) ||
                    ((_ctx.data.FormData.channelCode == 'Checkout' ||
                      _ctx.data.FormData.channelCode.toLocaleLowerCase().includes('nuvei')) &&
                      [2, 3, 4, 5, 6].includes(_ctx.data.FormData.orderStatus)) ||
                    ((_ctx.data.FormData.channelCode == 'Checkout' ||
                      _ctx.data.FormData.channelCode.toLocaleLowerCase().includes('nuvei')) &&
                      [1].includes(_ctx.data.FormData.orderStatus) &&
                      _ctx.data.FormData.checkoutUrl)
                )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_ctx.data.FormData.accountType)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_99, [
                                            _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t("cashier.paymentType")), 1),
                                            _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.data.FormData.accountType == "GOOGLEPAY"
                        ? "Google Pay"
                        : _ctx.data.FormData.accountType == "APPLEPAY"
                        ? "Apple Pay"
                        : _ctx.data.FormData.accountType), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.data.FormData.bankName)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_102, [
                                            _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.$t("cashier.bank")), 1),
                                            _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.data.FormData.bankName), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.data.FormData.paymentCode && !_ctx.isCanSerialize(_ctx.data.FormData?.paymentCode))
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_105, [
                                            _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.data.FormData.channelCode == "DukPay" &&
                        [_ctx.data.FormData.accountType, _ctx.data.FormData.paymentType].includes("SPEI")
                          ? "CLABE Code"
                          : _ctx.$t("cashier.paymentCode")), 1),
                                            _createElementVNode("div", _hoisted_107, [
                                              _createTextVNode(_toDisplayString(_ctx.data.FormData.paymentCode) + " ", 1),
                                              _createElementVNode("span", {
                                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.copy(_ctx.data.FormData.paymentCode)))
                                              }, _hoisted_109)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.data.FormData.vaNumber)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_110, [
                                            _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.$t("cashier.vaNumber")), 1),
                                            _createElementVNode("div", _hoisted_112, [
                                              _createTextVNode(_toDisplayString(_ctx.data.FormData.vaNumber) + " ", 1),
                                              _createElementVNode("span", {
                                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.copy(_ctx.data.FormData.vaNumber)))
                                              }, _hoisted_114)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                    _ctx.data.FormData.orderStatus == 1 &&
                      _ctx.data.FormData.checkoutUrl &&
                      _ctx.data.FormData.actionType !== 'COMPONENT' &&
                      _ctx.data.FormData.actionType !== 'CARDFORM' &&
                      !_ctx.isUnlimitPayfacChannel(_ctx.data.FormData.channelCode)
                  )
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_115, [
                                            _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t("cashier.link")), 1),
                                            _createElementVNode("div", _hoisted_117, [
                                              _createElementVNode("div", {
                                                class: "a",
                                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toPay && _ctx.toPay(...args)))
                                              }, _toDisplayString(_ctx.data.FormData.channelCode == "Checkout" ||
                        _ctx.data.FormData.channelCode.toLocaleLowerCase().includes("nuvei")
                          ? "3DS"
                          : _ctx.$t("cashier.pay")), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                    _ctx.data.FormData.qrCode ||
                      _ctx.data.FormData.vaNumber ||
                      (_ctx.data.FormData.paymentCode && !_ctx.isCanSerialize(_ctx.data.FormData?.paymentCode))
                  )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                            _createElementVNode("li", null, [
                                              _createElementVNode("div", _hoisted_118, [
                                                _createVNode(_component_VueQrcode, {
                                                  value: 
                          _ctx.data.FormData.qrCode ||
                            _ctx.data.FormData.vaNumber ||
                            _ctx.data.FormData.paymentCode
                        ,
                                                  tag: "img",
                                                  options: {
                          width: 140,
                          margin: 0
                        }
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            (_ctx.data.FormData.orderStatus == 1)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_119, [
                                                  _createElementVNode("div", _hoisted_120, [
                                                    (_ctx.data.FormData.accountType == 'DIRECT')
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_121, _toDisplayString(_ctx.$t("cashier.useBank", { name: _ctx.data.FormData.bankName })), 1))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.data.FormData.accountType == 'QRIS')
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_122, _toDisplayString(_ctx.$t("cashier.useQRIS", { name: _ctx.data.FormData.accountType })), 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (_ctx.data.FormData?.paymentCode && _ctx.isCanSerialize(_ctx.data.FormData?.paymentCode))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                            _createElementVNode("li", _hoisted_123, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.payToAccount")), 1)
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.data.FormData.paymentCode), (val, key) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                val
                                                  ? (_openBlock(), _createElementBlock("li", _hoisted_124, [
                                                      _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.resverText(key)), 1),
                                                      _createElementVNode("div", _hoisted_126, [
                                                        _createTextVNode(_toDisplayString(val) + " ", 1),
                                                        _createElementVNode("div", {
                                                          class: "copy",
                                                          onClick: ($event: any) => (_ctx.copy(val))
                                                        }, _hoisted_129, 8, _hoisted_127)
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            }), 256))
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      _hoisted_130,
                                      _createElementVNode("li", _hoisted_131, [
                                        _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t("cashier.orderTime")), 1),
                                        _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.FormatDateZone(_ctx.data.FormData.creationAt) || "--"), 1)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.showDwonMore)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_134, _hoisted_136))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                      (_ctx.showPayfacCardFormPanel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                            _hoisted_138,
                            _createElementVNode("div", _hoisted_140, [
                              _createVNode(_component_van_form, {
                                onSubmit: _ctx.CreateCardPay,
                                "validate-trigger": "onChange"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.cardHolderName")), 1),
                                    _createVNode(_component_van_field, {
                                      modelValue: _ctx.cardFormData.cardHolderName,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.cardFormData.cardHolderName = $event)),
                                      name: "cardHolderName",
                                      placeholder: `Jordan Smith`,
                                      rules: [{ required: true, message: _ctx.$t('required') }]
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_142, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.cardNumber")), 1),
                                    _createVNode(_component_van_field, {
                                      modelValue: _ctx.cardFormData.cardNumber,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.cardFormData.cardNumber = $event)),
                                      name: "cardNumber",
                                      placeholder: `1234 1234 1234 1234`,
                                      type: "digit",
                                      minlength: 14,
                                      maxlength: 23,
                                      clearable: "",
                                      formatter: _ctx.formatterNumber,
                                      "validate-trigger": "onChange",
                                      rules: [{ validator: _ctx.validatorCardNumber }]
                                    }, {
                                      "right-icon": _withCtx(() => [
                                        _createElementVNode("div", _hoisted_143, [
                                          (
                            !_ctx.cardFormData.cardNumber ||
                              _ctx.cardFormData.cardNumber.startsWith('0') ||
                              _ctx.cardFormData.cardNumber.startsWith('4') ||
                              _ctx.cardFormData.cardNumber.startsWith('7')
                          )
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_144, _hoisted_146))
                                            : _createCommentVNode("", true),
                                          (
                            !_ctx.cardFormData.cardNumber ||
                              _ctx.cardFormData.cardNumber.startsWith('0') ||
                              _ctx.cardFormData.cardNumber.startsWith('2') ||
                              _ctx.cardFormData.cardNumber.startsWith('5') ||
                              _ctx.cardFormData.cardNumber.startsWith('7')
                          )
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_147, _hoisted_152))
                                            : _createCommentVNode("", true),
                                          (_ctx.cardFormData.cardNumber && _ctx.cardFormData.cardNumber.startsWith('6'))
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_153, _hoisted_156))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "formatter", "rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_157, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.expiryDate")), 1),
                                    _createVNode(_component_van_field, {
                                      modelValue: _ctx.cardFormData.expriyDate,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.cardFormData.expriyDate = $event)),
                                      name: "expriyDate",
                                      placeholder: "MM/YY",
                                      maxlength: 5,
                                      clearable: "",
                                      onInput: _ctx.formatterDate,
                                      rules: [{ validator: _ctx.validatorDate }]
                                    }, null, 8, ["modelValue", "onInput", "rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_158, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.cvv")), 1),
                                    _createVNode(_component_van_field, {
                                      modelValue: _ctx.cardFormData.cvv,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.cardFormData.cvv = $event)),
                                      name: "cvv",
                                      placeholder: "CVV",
                                      type: "digit",
                                      maxlength: 4,
                                      rules: [{ required: true, message: _ctx.$t('required') }]
                                    }, {
                                      "right-icon": _withCtx(() => [
                                        _hoisted_159
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_160, [
                                    _createVNode(_component_van_checkbox, {
                                      modelValue: _ctx.remeberCheck,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.remeberCheck = $event)),
                                      shape: "square",
                                      "icon-size": "16px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("remeber")), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _createVNode(_component_van_button, {
                                    round: "",
                                    block: "",
                                    type: "primary",
                                    "native-type": "submit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_161, [
                                        _hoisted_162,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.pay")), 1)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onSubmit"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.data.FormData.orderStatus == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                            _hoisted_164,
                            (_ctx.showSunpayPay)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                  _createElementVNode("div", _hoisted_166, [
                                    _createElementVNode("img", {
                                      src: `${_ctx.BASE_URL}images/sunpay.png`
                                    }, null, 8, _hoisted_167),
                                    _hoisted_168
                                  ]),
                                  _createElementVNode("a", {
                                    class: "button",
                                    href: _ctx.data.FormData?.commPageUrl,
                                    target: "_self"
                                  }, "Pay", 8, _hoisted_169)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_170,
                      (_ctx.data.FormData.orderStatus == 1 && false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                            _createElementVNode("div", _hoisted_173, _toDisplayString(_ctx.$t("cashier.paid")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.data.FormData.channelCode === 'LinkedPay')
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 2,
                      ref: "LinkedPayForm",
                      action: _ctx.data.FormData.extend.checkoutUrl || _ctx.data.FormData.checkoutUrl,
                      method: "post",
                      target: "myIframe"
                    }, [
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "merchantNo",
                        value: _ctx.data.FormData.extend.merchantNo || _ctx.data.FormData.merchantNo
                      }, null, 8, _hoisted_175),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "merOrderNo",
                        value: _ctx.data.FormData.extend.orderNo || _ctx.data.FormData.orderNo
                      }, null, 8, _hoisted_176),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "notifyUrl",
                        value: _ctx.data.FormData.extend.notifyUrl || _ctx.data.FormData.notifyUrl
                      }, null, 8, _hoisted_177),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "ipAddress",
                        value: 
                _ctx.data.FormData.customerIP || _ctx.data.FormData.extend.customerIP || '104.243.23.241'
              
                      }, null, 8, _hoisted_178),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "currencyCode",
                        value: _ctx.data.FormData.currency
                      }, null, 8, _hoisted_179),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "amount",
                        value: _ctx.data.FormData.amount
                      }, null, 8, _hoisted_180),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "returnUrl",
                        value: 
                (_ctx.data.FormData.extend.syncNotifyUrl || _ctx.data.FormData.syncNotifyUrl || '') +
                  `${_ctx.data.path}/cashier/payin?k=${_ctx.data.token}`
              
                      }, null, 8, _hoisted_181),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "websiteUrl",
                        value: _ctx.data.path
                      }, null, 8, _hoisted_182)
                    ], 8, _hoisted_174))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  ref: "NuveiForm",
                  action: _ctx.data.FormData.extend.checkoutUrl || _ctx.data.FormData.checkoutUrl,
                  method: "post",
                  target: "myIframe"
                }, [
                  _createElementVNode("input", {
                    type: "hidden",
                    id: "creq",
                    name: "creq",
                    value: _ctx.data.FormData.challengeRequired
                  }, null, 8, _hoisted_184)
                ], 8, _hoisted_183)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["close", { open: _ctx.iframeUrl || _ctx.showIframeUrl }]),
                onClick: _cache[18] || (_cache[18] = 
          () => {
            _ctx.iframeUrl = '';
            _ctx.showIframeUrl = false;
          }
        )
              }, [
                _createVNode(_component_van_icon, { name: "arrow-down" })
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["iframe", { open: _ctx.iframeUrl || _ctx.showIframeUrl }])
              }, [
                (!_ctx.iframeUrl && !_ctx.data.FormData.channelCode.toLocaleLowerCase().includes('nuvei'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                      _createVNode(_component_van_icon, { name: "replay" }),
                      _hoisted_186
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("iframe", {
                  src: _ctx.iframeUrl,
                  frameborder: "0",
                  name: "myIframe",
                  id: "myIframe",
                  seamless: ""
                }, null, 8, _hoisted_187),
                (_ctx.showPayfacIframeLoadingMask)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_188, _hoisted_190))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.showPayfacTransition)
                ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                    _createElementVNode("div", _hoisted_192, [
                      _hoisted_193,
                      _createElementVNode("h3", null, _toDisplayString(_ctx.payfacTransitionTitle), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.payfacTransitionMessage), 1),
                      _createElementVNode("div", _hoisted_194, _toDisplayString(_ctx.data.FormData.currency) + " " + _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_195, [
              (
          _ctx.CashChannelList?.length &&
            !_ctx.CashChannelList[0].businessCashierName &&
            _ctx.data.dev !== 'sunpaysandbox' &&
            _ctx.data.dev !== 'sunpayprod' &&
            false
        )
                ? (_openBlock(), _createBlock(_component_i18n_t, {
                    key: 0,
                    keypath: "cashier.copyright",
                    scope: "global"
                  }, {
                    mail: _withCtx(() => [
                      _hoisted_196
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
              ? (_openBlock(), _createElementBlock("div", _hoisted_197, _hoisted_199))
              : _createCommentVNode("", true),
            (_ctx.isLoadingToast)
              ? (_openBlock(), _createElementBlock("div", _hoisted_200, _hoisted_202))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
}